import React from 'react'
import { useScrollPositionAfterThreshold } from '@/hooks'
import useNavbarFlatGround from '@/hooks/useNavbarFlatGround'
import SportEventMatchHeader from '@/features/market/question-header/SportEventMatchHeader'

// Page scroll (px) past which the sticky scoreboard switches to its compact state
const COMPACT_SCROLL_THRESHOLD = 32

/**
 * Mobile detail page scoreboard: flush with the fixed navbar (--navbar-compact-height, plus any
 * top strip) and the screen edges, sticks under the navbar and collapses to the
 * compact header once the page is scrolled.
 * While stuck it sits flush under the navbar, so the navbar's fading lower edge
 * is flattened the same way the desktop condensed header does it.
 */
const SportEventMobileMatchHeader = ({ question, categories }) => {
  const compact = useScrollPositionAfterThreshold(COMPACT_SCROLL_THRESHOLD)
  useNavbarFlatGround(compact)

  return (
    // -mx-4 cancels the market page's 16px mobile gutter (ViewMarketPage.scss) so the
    // scoreboard runs edge to edge.
    <div className="sticky z-40 -mx-4 -mt-4 bg-surface-2 pb-4 top-[calc(var(--top-strip-offset,0px)+var(--navbar-compact-height))]">
      <SportEventMatchHeader question={question} categories={categories} compact={compact} />
    </div>
  )
}

export default SportEventMobileMatchHeader
